import { language } from "@chef/constants";

export const intl = (
  {
    se: {
      A_DELIVERY_IS_UNDERWAY_TO_YOUR_OLD_ADDRESS:
        "Du har en leverans påväg till din gamla adress",
      YOUR_CHANGE_IS_VALID_FROM: "Din ändring träder i kraft efter den",
      YOU_HAVE_PREVIOUSLY_REQUESTED_A_DELIVERY_THAT_IS_BEING_SENT_TO_YOUR_OLD_ADDRESS:
        "Du har tidigare beställt en leverans som skickas till din gamla adress.",

      SAVE_CHANGES: "Spara ändring",
      CANCEL: "Avbryt",
    },

    dk: {
      A_DELIVERY_IS_UNDERWAY_TO_YOUR_OLD_ADDRESS:
        "Du har en levering på vej til din gamle adresse",
      YOUR_CHANGE_IS_VALID_FROM: "Din ændring træder i kraft den",
      YOU_HAVE_PREVIOUSLY_REQUESTED_A_DELIVERY_THAT_IS_BEING_SENT_TO_YOUR_OLD_ADDRESS:
        "Du har tidligere bestilt en levering, som sendes til din gamle adresse.",
      SAVE_CHANGES: "Helt i orden",
      CANCEL: "Afbryd",
    },
    no: {
      A_DELIVERY_IS_UNDERWAY_TO_YOUR_OLD_ADDRESS:
        "Du har en levering på vei til din gamle adresse",
      YOUR_CHANGE_IS_VALID_FROM: "Din endring trer i kraft den",
      YOU_HAVE_PREVIOUSLY_REQUESTED_A_DELIVERY_THAT_IS_BEING_SENT_TO_YOUR_OLD_ADDRESS:
        "Du har tidligere bestilt en levering, som sendes til din gamle adresse.",
      SAVE_CHANGES: "Helt i orden",
      CANCEL: "Avbryt",
    },
  } as const
)[language];
